import * as R from "ramda";
import store from '../index';
import { path } from "ramda";

const searchPerm = (data, value, permAreaKey, permTypeKey) => {
  return (R.filter(R.allPass(
    [R.propEq('permAreaKey', permAreaKey),
      R.propEq('permTypeKey', permTypeKey),
      R.propEq('value', value)]))(data)).length > 0;
};

const checkPermission = (currentUserId, permission, { permAreaKey, permTypeKey, idForCheckingAuthor }) => {
  if (searchPerm(permission, 'off', permAreaKey, 'view')) {
    return false;
  }
  const on = searchPerm(permission, 'on', permAreaKey, permTypeKey);
  if (!on) {
    const own = searchPerm(permission, 'own', permAreaKey, permTypeKey);
    if (own && idForCheckingAuthor && idForCheckingAuthor === currentUserId) {
      return true;
    }
    return own && !idForCheckingAuthor ? 'own' : false;
  }
  return on;
};

export default function hasAccess(permissionSetForCheck) {
  let permission;
  let currentUserId;
  if (store) {
    const user = path(['users', 'userProfile'], store.getState());
    permission = path(['permission'], user);
    currentUserId = path(['id'], user);
  }
  if (permission && !R.isEmpty(permissionSetForCheck)) {
    if (Array.isArray(permissionSetForCheck) && permissionSetForCheck.length === 2) {
      return checkPermission(currentUserId, permission, permissionSetForCheck[0])
        || checkPermission(currentUserId, permission, permissionSetForCheck[1]);
    }
    return checkPermission(currentUserId, permission, permissionSetForCheck);
  } else if (permissionSetForCheck.permAreaKey === 'forUnAuth') {
    return true;
  } else if (permission) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/permissionChecker.js